// extracted by mini-css-extract-plugin
export default {"groupsMenu":"GroupsMenu_groupsMenu__A46z6","hiddenOnMobile":"GroupsMenu_hiddenOnMobile__1Dzw0"};